import React from "react";
import ReactSimpleRange from "react-simple-range";

import { getCarSetting, updateCar } from "../../model/car";
import { getLoggedProfile } from "../../model/profile";

import { commonErr } from "../common/errors";
import { formatPrice } from "../common/common";
import { MessageBox, MessageLine } from "../common/messagebox";
import { LoadingInline, LoadingOverlay } from "../common/loading";

export default class CarSettingExtraFee extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
			isDelivery: false,
		};
	}

	init = (car) => {
		getCarSetting({ carId: car.id }).then((carSettingResp) => {
			const setting = carSettingResp.data.data;
			const additionalPrice = car.additionalPrice;

			if (setting) {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,

					isBatteryChargingPrice: additionalPrice ? additionalPrice.batteryChargingPriceEnable === 1 : false,
					batteryChargingPrice:
						additionalPrice && additionalPrice.batteryChargingPrice > 0
							? additionalPrice.batteryChargingPrice
							: setting.batteryChargingPriceRecommend,

					isLimited: car.limitEnable === 1,
					limited: car.limitKM,
					limitedPrice: car.limitPrice,

					isOverTimePrice: additionalPrice ? additionalPrice.overTimePriceEnable === 1 : false,
					overTimePrice:
						additionalPrice && additionalPrice.overTimePrice > 0
							? additionalPrice.overTimePrice
							: setting.overTimePriceRecommend,
					isWashingPrice: additionalPrice ? additionalPrice.washingPriceEnable === 1 : false,
					washingPrice:
						additionalPrice && additionalPrice.washingPrice > 0
							? additionalPrice.washingPrice
							: setting.washingPriceRecommend,

					isDeodorisePrice: additionalPrice ? additionalPrice.deodorisePriceEnable === 1 : false,
					deodorisePrice:
						additionalPrice && additionalPrice.deodorisePrice > 0
							? additionalPrice.deodorisePrice
							: setting.deodorisePriceRecommend,

					isMaxHoursOvertime: additionalPrice ? additionalPrice.maxHoursOvertimeEnable === 1 : false,
					maxHoursOvertime:
						additionalPrice && additionalPrice.maxHoursOvertime > 0
							? additionalPrice.maxHoursOvertime
							: setting.maxHoursOvertimeRecommend,

					car,
					setting,
				});
			} else {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,
				});
			}
		});
	};

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	toggleCheckBox = (e) => {
		this.setState({
			[e.target.name]: e.target.checked,
		});
	};

	onHandleRangeChange = (range) => {
		this.setState({
			[range.id]: range.value,
		});
	};

	hideMessageBox = () => {
		this.setState({
			updateErrMsg: "",
		});
	};

	updateCarInfo = () => {
		const {
			isLimited,
			limitedPrice,
			limited,
			isOverTimePrice,
			overTimePrice,
			isWashingPrice,
			washingPrice,
			isDeodorisePrice,
			deodorisePrice,
			isBatteryChargingPrice,
			batteryChargingPrice,
			isMaxHoursOvertime,
			maxHoursOvertime,
		} = this.state;

		this.setState({
			err: commonErr.LOADING,
		});

		const data = {
			limitEnable: isLimited,
			limitKM: limited,
			limitPrice: limitedPrice,
			overTimePriceEnable: isOverTimePrice,
			overTimePrice: overTimePrice,
			maxHoursOvertimeEnable: isOverTimePrice,
			maxHoursOvertime: maxHoursOvertime,
			washingPriceEnable: isWashingPrice,
			washingPrice: washingPrice,
			deodorisePriceEnable: isDeodorisePrice,
			deodorisePrice: deodorisePrice,
			batteryChargingPriceEnable: isBatteryChargingPrice,
			batteryChargingPrice: batteryChargingPrice,
		};

		updateCar(this.state.car.id, data).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		const {
			err,
			updateErrMsg,
			isLimited,
			limitedPrice,
			limited,
			isOverTimePrice,
			overTimePrice,
			isWashingPrice,
			washingPrice,
			isDeodorisePrice,
			deodorisePrice,
			isBatteryChargingPrice,
			batteryChargingPrice,
			isMaxHoursOvertime,
			maxHoursOvertime,
			car,
			setting,
		} = this.state;

		if (err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!car || !setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			content = (
				<div className="content">
					{err === commonErr.LOADING && <LoadingOverlay />}
					{updateErrMsg && updateErrMsg !== "" && (
						<MessageBox
							error={err}
							message={updateErrMsg}
							show={updateErrMsg && updateErrMsg !== ""}
							hideModal={this.hideMessageBox.bind(this)}
						/>
					)}
					<div className="content-container setting-extra-fee">
						<div className="form-default">
							<h3>
								Giới hạn số km
								<div className="tooltip">
									<i className="ic ic-question-mark" />
									<div className="tooltip-text">
										Áp dụng trong trường hợp khách hàng đi quá số KM quy định. (* Nếu khách hàng thuê từ 2 ngày: Giới
										hạn số KM của chuyến đi = Giới hạn số KM/ngày x Số ngày thuê).
									</div>
								</div>
							</h3>
							<div className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0px", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										name="isLimited"
										id="cb-instant-limited"
										type="checkbox"
										checked={this.state.isLimited}
										onClick={(e) => this.toggleCheckBox(e)}
									/>
									<label className="switch-label" htmlFor="cb-instant-limited" />
								</div>
							</div>
						</div>
						{isLimited && (
							<React.Fragment>
								<div className="col-1">
									<div className="line-form end">
										<div className="tilte-range">Số km tối đa</div>
										<div className="range-slider">
											<ReactSimpleRange
												step={50}
												min={setting.limitKMMin}
												max={setting.limitKMMax}
												value={limited}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onHandleRangeChange}
												id="limited"
											/>
											<span style={{ float: "right", fontSize: "14px" }}>{`${limited}km/ngày`}</span>
											<div className="space m"></div>
											<span className="suggest-note">Số km đề xuất: {`${setting.limitKMRecommend}km/ngày`}</span>
										</div>
									</div>
								</div>
								<div className="col-2">
									<div className="line-form end">
										<div className="tilte-range">Phí vượt giới hạn</div>
										<div className="range-slider">
											<ReactSimpleRange
												step={1000}
												min={setting.limitPriceMin}
												max={setting.limitPriceMax}
												value={limitedPrice}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onHandleRangeChange}
												id="limitedPrice"
											/>
											<span style={{ float: "right", fontSize: "14px" }}>{formatPrice(limitedPrice)}/km</span>
											<div className="space m"></div>
											<span className="suggest-note">Phí đề xuất: {formatPrice(setting.limitPriceRecommend)}/km</span>
										</div>
									</div>
								</div>
							</React.Fragment>
						)}
						<div className="clear line"></div>
						<div className="form-default">
							<h3>
								Quá giờ
								<div className="tooltip">
									<i className="ic ic-question-mark" />
									<div className="tooltip-text">
										Áp dụng trong trường hợp khách hàng trả xe trễ hơn so với thời gian đã đặt trên ứng dụng.
									</div>
								</div>
							</h3>
							<div className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0px", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										name="isOverTimePrice"
										id="cb-overtime"
										type="checkbox"
										checked={isOverTimePrice}
										onClick={(e) => this.toggleCheckBox(e)}
									/>
									<label className="switch-label" htmlFor="cb-overtime" />
								</div>
							</div>
						</div>
						{isOverTimePrice && (
							<React.Fragment>
								<div className="col-1">
									<div className="line-form end">
										<div className="tilte-range">Phí quá giờ</div>
										<div className="range-slider">
											<ReactSimpleRange
												step={10000}
												min={setting.overTimePriceMin}
												max={setting.overTimePriceMax}
												value={overTimePrice}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												id="overTimePrice"
												onChange={this.onHandleRangeChange}
											/>
											<span style={{ float: "right", fontSize: "14px" }}>{`${formatPrice(overTimePrice)}/giờ`}</span>
											<div className="space m"></div>
											<span className="suggest-note">
												Phí đề xuất: {`${formatPrice(setting.overTimePriceRecommend)}/giờ`}
											</span>
										</div>
									</div>
								</div>
								<div className="col-2">
									<div className="line-form end">
										<div className="tilte-range">Tính giá 1 ngày nếu quá</div>
										<div className="range-slider">
											<ReactSimpleRange
												step={1}
												min={setting.maxHoursOvertimeMin}
												max={setting.maxHoursOvertimeMax}
												value={maxHoursOvertime}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onHandleRangeChange}
												id="maxHoursOvertime"
											/>
											<span style={{ float: "right", fontSize: "14px" }}>{maxHoursOvertime} giờ</span>
											<div className="space m"></div>
											<span className="suggest-note">Phí đề xuất: {setting.maxHoursOvertimeRecommend} giờ</span>
										</div>
									</div>
								</div>
							</React.Fragment>
						)}
						<div className="clear line"></div>
						<div className="form-default">
							<h3>
								Vệ sinh xe
								<div className="tooltip">
									<i className="ic ic-question-mark" />
									<div className="tooltip-text">
										Áp dụng trong trường hợp khách hàng trả xe có nhiều vết bẩn, bùn cát, sình lầy…, chủ xe cần phải vệ
										sinh lại trước khi giao cho khách sau.
									</div>
								</div>
							</h3>
							<div className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0px", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										id="cb-washing-price"
										type="checkbox"
										name="isWashingPrice"
										checked={isWashingPrice}
										onChange={(e) => this.toggleCheckBox(e)}
									/>
									<label className="switch-label" htmlFor="cb-washing-price" />
								</div>
							</div>
						</div>
						{isWashingPrice && (
							<div className="col-1">
								<div className="line-form end">
									{/* <div className="tilte-range">Phí</div> */}
									<div className="range-slider">
										<ReactSimpleRange
											step={10000}
											min={setting.washingPriceMin}
											max={setting.washingPriceMax}
											value={washingPrice}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#5fcf86"}
											thumbColor={"#141414"}
											onChange={this.onHandleRangeChange}
											id="washingPrice"
										/>
										<span style={{ float: "right", fontSize: "14px" }}>{formatPrice(washingPrice)}</span>
										<div className="space m"></div>
										<span className="suggest-note">Phí đề xuất: {formatPrice(setting.washingPriceRecommend)}/giờ</span>
									</div>
								</div>
							</div>
						)}
						<div className="clear line"></div>
						<div className="form-default">
							<h3>
								Khử mùi xe
								<div className="tooltip">
									<i className="ic ic-question-mark" />
									<div className="tooltip-text">
										Áp dụng trong trường hợp khách hàng trả xe có nhiều vết bẩn, bùn cát, sình lầy…, chủ xe cần phải vệ
										sinh lại trước khi giao cho khách sau.
									</div>
								</div>
							</h3>
							<div className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0px", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										id="cb-deodrise-price"
										name="isDeodorisePrice"
										type="checkbox"
										checked={isDeodorisePrice}
										onChange={(e) => this.toggleCheckBox(e)}
									/>
									<label className="switch-label" htmlFor="cb-deodrise-price" />
								</div>
							</div>
						</div>
						{isDeodorisePrice && (
							<div className="col-1">
								<div className="line-form end">
									{/* <div className="tilte-range">Phí</div> */}
									<div className="range-slider">
										<ReactSimpleRange
											step={10000}
											min={setting.deodorisePriceMin}
											max={setting.deodorisePriceMax}
											value={deodorisePrice}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#5fcf86"}
											thumbColor={"#141414"}
											onChange={this.onHandleRangeChange}
											id="deodorisePrice"
										/>
										<span style={{ float: "right", fontSize: "14px" }}>{formatPrice(deodorisePrice)}/chuyến</span>
										<div className="space m"></div>
										<span className="suggest-note">
											Phí đề xuất: {formatPrice(setting.deodorisePriceRecommend)}/chuyến{" "}
										</span>
									</div>
								</div>
							</div>
						)}
						{car.optionsFuel === 3 && (
							<>
								<div className="clear line"></div>
								<div className="form-default">
									<h3>
										Phí sạc pin
										<div className="tooltip">
											<i className="ic ic-question-mark" />
											<div className="tooltip-text">
												Chi phí sạc pin cho riêng dòng xe điện, được tính dựa trên số km di chuyển
											</div>
										</div>
									</h3>
									<div className="position-relative pos-1">
										<div className="switch-on-off" style={{ right: "0px", position: "absolute", bottom: "10px" }}>
											<input
												className="switch-input"
												id="cb-charge"
												name="isBatteryChargingPrice"
												type="checkbox"
												checked={isBatteryChargingPrice}
												onChange={(e) => this.toggleCheckBox(e)}
											/>
											<label className="switch-label" htmlFor="cb-charge" />
										</div>
									</div>
								</div>
								{isBatteryChargingPrice && (
									<div className="col-1">
										<div className="line-form end">
											{/* <div className="tilte-range">Phí</div> */}
											<div className="range-slider">
												<ReactSimpleRange
													step={500}
													min={setting.batteryChargingPriceMin}
													max={setting.batteryChargingPriceMax}
													value={batteryChargingPrice}
													sliderSize={14}
													thumbSize={16}
													label={false}
													trackColor={"#5fcf86"}
													thumbColor={"#141414"}
													onChange={this.onHandleRangeChange}
													id="batteryChargingPrice"
												/>
												<span style={{ float: "right", fontSize: "14px" }}>{batteryChargingPrice / 1000}K/km</span>
												<div className="space m"></div>
												<span className="suggest-note">
													Phí đề xuất: {setting.batteryChargingPriceRecommend / 1000}K/km{" "}
												</span>
											</div>
										</div>
									</div>
								)}
							</>
						)}
						<div className="space clear"></div>
						<div className="line"></div>
						<a className="btn btn-primary btn--m" onClick={this.updateCarInfo}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}
		return content;
	}
}
